import Vue from 'vue'
import FastClick from 'fastclick'
import VueRouter from 'vue-router'
import App from './App.vue'
import router from './router'
import store from './store'
import '../src/assets/css/font.css'
import '../src/assets/css/iconfont.css'
import 'vant/lib/index.css'
import './utils/back'
import VConsole from 'vconsole'
import myHeader from '@/views/components/header'
import myFooter from '@/views/components/footer'
// import 'lib-flexible'
import './utils/rem.js'


let NODE_ENV = process.env.NODE_ENV
if(NODE_ENV !== 'production') {
  new VConsole()
}
Vue.use(VueRouter)
Vue.component('myHeader', myHeader)
Vue.component('myFooter', myFooter)
FastClick.attach(document.body)

Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
